// extracted by mini-css-extract-plugin
export default {"root":"vBYg_tuOicBDnv26JQWc"};